export enum DownPaymentRatioEnum {
  TWENTY_MORE = "TWENTY_MORE",
  TWENTY_LESS = "TWENTY_LESS",
  UNKNOWN = "UNKNOWN",
}
